import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface ITableCertificationParams {
  // table vizportal id.
  id: string;
  luid?: string;
  isCertified: boolean;
  certificationNote: string;
}

export class SetTableCertificationRequest extends Request<ITableCertificationParams, IResult> {
  constructor(params: ITableCertificationParams) {
    super('setTableCertification', params);
  }
}
